'use client';

import React from 'react';
import { Calendar, Users, Tag, Coins, Bell, Plus } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface ClientsHeaderProps {
  clientsCount: number;
  onOpenNewClientModal?: () => void;
}

export default function ClientsHeader({
  clientsCount,
  onOpenNewClientModal
}: ClientsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2">
      {/* Título y Conteo */}
      <div className="flex items-center gap-2">
        <h1 className="text-2xl md:text-[26px] font-bold text-slate-900 tracking-tight">
          Clientes y CRM
        </h1>
        <span className="text-slate-400 font-normal text-xl">·</span>
        <span className="text-slate-500 font-semibold text-base sm:text-lg">
          {clientsCount} registrados
        </span>
      </div>

      {/* Accesos rápidos y Botón Principal */}
      <div className="flex items-center gap-2.5 self-end sm:self-center">
        {onOpenNewClientModal && (
          <Button
            variant="primary"
            onClick={onOpenNewClientModal}
            className="shadow-sm"
          >
            <Plus className="w-4 h-4" />
            <span>Nuevo Cliente</span>
          </Button>
        )}
      </div>
    </div>
  );
}
